import { Container } from 'inversify';
import 'reflect-metadata';
import { FlightPathService } from '@/services/flightpathService';
import { FlightPathServiceInterface } from '@/flightpath-components/services/FlightPathServiceInterface';
import SERVICE_IDENTIFIER from '@/flightpath-components/services/identifiers';
// eslint-disable-next-line prefer-const
let container: Container = new Container();

container.bind<FlightPathServiceInterface>(SERVICE_IDENTIFIER.FLIGHT_PATH).to(FlightPathService);

export default container;
